// @flow
import React, {
  useRef,
  useState,
  createRef,
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import debounce from 'lodash.debounce';
import {
  Modal,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  subscriptionv2Actions,
  notificationActions,
  invoiceDetailsAction,
  inventoryItemsActions,
  inventoryPrinterLabelActions,
} from 'store/actions';
import formatAmount from 'utils/formatAmount';
import moment from 'moment-timezone';
import { SpButton } from 'components/DesignKit';
import AddItem from '../../../../InventoryOrders/components/ItemsList/components/AddNewItem';

import PlanDetails from './PlanDetails';
import AddNewProduct from './AddNewProduct';
import SelectCoupon from './SelectCoupon';
import AddCoupon from './AddNewCoupon';
import SelectTaxrate from './SelectTaxrate';
import AddTaxrate from './AddNewTax';

type Props = {
  close: Function,
  visible: boolean,
  submitting: boolean,
  selectedAccount: Object,
  subscriptionDetails: Object,
  plans: Array<Object>,
  planResult: Array<Object>,
  customerResult: Array<Object>,
  fetchPlanV2Search: Function,
  getCustomersList: Function,
  submit: Function,
  applyCoupon: Function,
  role: Object,
  applyTaxRate: Function,
  supportedCurrency: Array,
  getProductsList: Function,
  productsList: Array<Object>,
  addNewProcut: Function,
  validator: boolean,
  addedNewProduct: Object,
  subScriptionModal: Function,
  newCoupon: Object,
  addNewCoupon: Function,
  getTaxes: Function,
  taxList: Array<Object>,
  addNewTaxRate: Function,
  newTaxrate: Object,
  fetchInventoryItems: Function,
  inventoryItems: Array<Object>,
  fetchItemsList: Function,
  fetchPrinterLabelList: Function,
  fetchModifierItemsList: Function,
  itemsList: Array<Object>,
  modifierItemsList: Array<Object>,
  labelList: Array,
  addInventoryItems: Function,
  hanldleAddInventoryRedirect: Function,
  hanldleItemModalRedirect: Function,
  addedNewItem:Object,

};

const AddSubscription = (props: Props) => {
  const {
    visible,
    close,
    plans,
    planResult,
    customerResult,
    subscriptionDetails,
    submitting,
    selectedAccount,
    role,
    submit,
    fetchPlanV2Search,
    getCustomersList,
    applyCoupon,
    applyTaxRate,
    supportedCurrency,
    getProductsList,
    productsList,
    addNewProcut,
    validator,
    addedNewProduct,
    subScriptionModal,
    newCoupon,
    addNewCoupon,
    getTaxes,
    taxList,
    addNewTaxRate,
    newTaxrate,
    fetchInventoryItems,
    inventoryItems,
    addInventoryItems,
    fetchItemsList,
    fetchModifierItemsList,
    fetchPrinterLabelList,
    itemsList,
    modifierItemsList,
    labelList,
    hanldleAddInventoryRedirect,
    hanldleItemModalRedirect,
    addedNewItem,
  } = props;

  const [, forceUpdate] = useState();
  const location = useLocation();
  const planDetailsRef = createRef();
  const [refArray, setRefArray] = useState([planDetailsRef]);
  const current = 0;
  const currencyType = selectedAccount && selectedAccount.currency;
  const simpleValidator = useRef(new SimpleReactValidator());
  // eslint-disable-next-line max-len
  const [planAamount, setPlanAmount] = useState((subscriptionDetails && subscriptionDetails.planAmount) ? formatAmount(subscriptionDetails.planAmount / 100, currencyType) : '');
  // eslint-disable-next-line max-len
  const [billAmount, setBillAmount] = useState((subscriptionDetails && subscriptionDetails.planAmount) ? formatAmount((subscriptionDetails.planAmount / 100) * (subscriptionDetails.planQuantity), currencyType) : '');
  const [planName, setPlanName] = useState(subscriptionDetails ? subscriptionDetails.plan.name : '');
  const [prefix, setPrefix] = useState(subscriptionDetails
    ? (subscriptionDetails.currency && subscriptionDetails.currency.prefix)
    : (selectedAccount.currency && selectedAccount.currency.prefix));
  const [currencyCode, setCurrencyCode] = useState(subscriptionDetails
    ? (subscriptionDetails.currency && subscriptionDetails.currency.name)
    : (selectedAccount.currency && selectedAccount.currency.name));
  const [period, setPeriod] = useState(subscriptionDetails ? subscriptionDetails.planBillingPeriod : 1);
  const [descriptions, setDescriptions] = useState(subscriptionDetails ? subscriptionDetails.plan.description : '');
  const [counts, setCounts] = useState(subscriptionDetails ? subscriptionDetails.planTotalPayments : '');
  const [qtys, setQtys] = useState(subscriptionDetails ? subscriptionDetails.planQuantity : 1);
  const [planDate, setPlanDate] = useState('');
  const [pfrequency, setPfrequency] = useState(subscriptionDetails ? subscriptionDetails.planBillingFrequency : 'MONTH');
  const [startDates, setStartDates] = useState(false);
  const [plansGid, setPlansGid] = useState(subscriptionDetails ? subscriptionDetails.plan.gid : '');
  const [planList, setPlanList] = useState(plans);
  const [apiPlanDate, setApiPlanDate] = useState('');
  const [customerName, setCustomerName] = useState(subscriptionDetails ? subscriptionDetails.customer.name : '');
  // eslint-disable-next-line max-len
  const [applicationFee, setApplicationFee] = useState((subscriptionDetails && subscriptionDetails.applicationFeePercentage) ? formatAmount(subscriptionDetails.applicationFeePercentage / 100, currencyType) : '0.00');
  const [customerList, setCustomerList] = useState(customerResult);
  const [customersGid, setCustomersGid] = useState(subscriptionDetails ? subscriptionDetails.customer.gid : '');
  // eslint-disable-next-line max-len
  const [notify, setNotify] = useState((subscriptionDetails && subscriptionDetails.notificationType) ? subscriptionDetails.notificationType : 'Email');
  const [disableSubscriptionPlan, setDisableSubscriptionPlan] = useState(false);
  const [lineItemDtoList, setLineItemDtosList] = useState([{
    amount: 0,
    rate: 0,
    productGid: '',
    currencyCode: '',
    description: '',
    name: '',
    note: '',
    quantity: '1',
    recurring: false,
    itemGid: '',
    priceType: '',
  }]);
  const [disableButton, setDisableButton] = useState(false);
  const [addProductModal, setAddProductModal] = useState(false);
  const [addItemModal, setAddItemModal] = useState(false);
  const [addedProduct, setAddedProduct] = useState(false);
  const [addedItem, setAddedItem] = useState(false);
  const dateFormat = 'MMM DD, YYYY';
  const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  const [subscriptionAmount, setSubScriptionAmount] = useState();
  const [updatedCoupon, setUpdatedCoupon] = useState({});
  const [couponRedirect, setCouponRedirect] = useState(false);
  const [addCouponModal, setAddCouponModal] = useState(false);
  const [selectCouponModal, setSelectCouponModal] = useState(false);
  const [selectTaxrateModal, setSelectTaxrateModal] = useState(false);
  const [addTaxModal, setAddTaxModal] = useState(false);
  const [allTaxes, setAllTaxes] = useState(taxList);
  const [taxRedirect, setTaxRedirect] = useState(false);
  const [allSelectedTaxrates, setAllSelectedTaxrates] = useState([]);
  const [cupoAaddon, setCupoAaddon] = useState({});
  const [allRatesAaddon, setAllRatesAaddon] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [shippingAmount, setShippingAmount] = useState(subscriptionDetails ? subscriptionDetails.shippingAmount : null);
  const legacySubscriber = selectedAccount && selectedAccount.legacySubscription;
  const [redirectUrl, setRedirectUrl] = useState('');
  const [delayStartDate, setDelayStartDate] = useState(null);
  const [freeTrialDays, setFreeTrialDays] = useState(null);
  const [feesType, setFeesType] = useState('PERCENT');
  const [overdueFee, setOverdueFee] = useState(null);
  const [limitPaymentMethods, setLimitPaymentMethods] = useState(null);
  const [allowManualPayment, setAllowManualPayment] = useState(false);
  const [nextAttempt, setNextAttempt] = useState(null);
  const [addToPlanManager, setAddToPlanManager] = useState(false);
  const [pauseType1, setPauseType1] = useState('');
  const [email1, setEmail1] = useState('');
  const [surCharge, setSurCharge] = useState(null);

  const planData = {
    planAamount,
    billAmount,
    planName,
    shippingAmount,
    period,
    descriptions,
    counts,
    qtys,
    planDate,
    apiPlanDate,
    pfrequency,
    startDates,
    plansGid,
    planList,
    applicationFee,
    disableSubscriptionPlan,
    subscriptionAmount,
    notify,
    prefix,
    currencyCode,
    lineItemDtoList,
    cupoAaddon,
    allRatesAaddon,
    totalAmount,
    redirectUrl,
    delayStartDate,
    freeTrialDays,
    feesType,
    overdueFee,
    limitPaymentMethods,
    allowManualPayment,
    nextAttempt,
    addToPlanManager,
    pauseType1,
    email1,
    customersGid,
    customerList,
    customerName,
    surCharge,
  };

  const fetchPlanDetails = (search) => {
    fetchPlanV2Search(search);
  };

  const fetchCustomerDetails = (search) => {
    getCustomersList(search);
  };
  const debouncedFetchInventoryItems = debounce(fetchInventoryItems, 2000, { leading: true });

  const getDataItems = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    const sortBy = parsed.sortBy || 'name';
    const direction = parsed.direction || 'ASC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    // const sortParam = '&sortBy=sortOrder&direction=ASC';
    // const filterParam = parsed.filterParams || '';
    // const filterParams = (preserveParam ? preserveParam.filterParams : filterParam || '');
    // const nameSearch = searchText ? (searchText === '' ? null : `&name.LIKE=${searchText}`) : null;
    debouncedFetchInventoryItems({
      currentPage, sortParams,
    });
  };


  useEffect(() => {
    getDataItems(location.search);
  }, [selectedAccount]);

  useEffect(() => {
    getProductsList();
  }, [selectedAccount]);

  const getListItems = () => {
    const sortParams = '&sortBy=name&direction=ASC';
    const currentPage = 1;
    const filterParams = '';
    debouncedFetchInventoryItems({
      currentPage, sortParams, filterParams,
    });
  };

  useEffect(() => {
    setPlanList(planResult || planList);
  }, [planResult]);

  useEffect(() => {
    setCustomerList(customerResult);
  }, [customerResult]);

  useEffect(() => {
    if (!validator) {
      setAddProductModal(false);
      setAddCouponModal(false);
      setAddTaxModal(false);
      setAddItemModal(false);
    }
  }, [validator]);

  useEffect(() => {
    if (newCoupon.gid && couponRedirect) {
      setUpdatedCoupon(newCoupon);
    }
  }, [newCoupon]);

  const fetchCustomer = (searchText) => {
    getCustomersList(searchText);
  };

  const addNewProductforPlan = () => {
    setAddProductModal(true);
  };

  const addNewItemforPlan = () => {
    setAddItemModal(true);
    fetchItemsList('&sortBy=name&direction=DESC');
    fetchModifierItemsList('&sortBy=name&direction=DESC');
    fetchPrinterLabelList('&sortBy=createdAt&direction=DESC');
    hanldleItemModalRedirect(true);
  };

  const addNewCuponforPlan = (value) => {
    setSelectCouponModal(value);
  };

  const addNewTaxforPlan = (value) => {
    setSelectTaxrateModal(value);
  };

  const updateCoupon = (Coupon: Object) => {
    setUpdatedCoupon(Coupon);
    setSelectCouponModal(false);
  };
  const updateShippingFee = (amount: Number) => {
    setShippingAmount(amount);
  };

  const removeCoupon = () => {
    setUpdatedCoupon({});
    // setCouponMsg('');
    simpleValidator.current.purgeFields();
  };

  const addCoupon = (coupon: Object) => {
    const {
      name,
      percentageOff,
      amountOff,
      validity,
      expiresAt,
      maximumRedemption,
      code,
      minimumAmount,
      promotionalRedeemed,
      promoExpiresAt,
      promotional,
      customerGid,
      validiyInMonths,
    } = coupon;
    const params = {
      active: true,
      name,
      percentageOff: (percentageOff ? parseFloat(percentageOff) : null),
      amountOff: (amountOff ? parseInt((amountOff).replace(/[_\W]+/g, ''), 10) : null),
      validity,
      expiresAt,
      maximumRedemption: (maximumRedemption ? parseInt(maximumRedemption, 10) : null),
      validiyInMonths: (validiyInMonths ? parseInt(validiyInMonths, 10) : null),
      currencyCode,
    };
    const payload = {
      active: true,
      code,
      enabledForCheckout: true,
      expiresAt: promoExpiresAt,
      maximumRedemption: promotionalRedeemed ? parseInt(promotionalRedeemed, 10) : null,
      minimumAmount: minimumAmount ? parseInt((minimumAmount).replace(/[_\W]+/g, ''), 10) : null,
      minimumAmountCurrency: currencyCode,
      restrictedToCustomers: [
        customerGid,
      ],
    };
    subScriptionModal(true);
    if (promotional) {
      addNewCoupon({
        params,
        payload,
      });
    } else if (!promotional) {
      addNewCoupon({
        params,
      });
    }
    setCouponRedirect(true);
  };

  const newCouponAdd = () => {
    setSelectCouponModal(false);
    setAddCouponModal(true);
  };

  const addNewProduct = (newProduct: Object) => {
    const {
      productName,
      currency,
      productDescription,
      amount,
      productNotes,
      upfront,
    } = newProduct;

    const productAmount = amount.replace(/[. ,:-]+/g, '');

    const params = {
      name: productName,
      currencyCode: currency,
      description: productDescription,
      amount: Number(productAmount),
      note: productNotes,
      paymentMethodType: [
        'CARD',
      ],
      statementDescription: '',
      upfront,
    };

    addNewProcut({
      params,
    });
    subScriptionModal(true);
    setAddedProduct(true);
  };

  useEffect(() => {
    if (newTaxrate.gid && taxRedirect) {
      const listOfTaxes = [...allSelectedTaxrates];
      const taxRates = {};
      Object.assign(taxRates, newTaxrate);
      const taxRate = {
        taxRates,
      };
      listOfTaxes.push(taxRate);
      setAllSelectedTaxrates(listOfTaxes);
    }
  }, [newTaxrate]);

  useEffect(() => {
    setAllTaxes(taxList);
  }, [taxList]);

  const newTaxAdd = () => {
    setSelectTaxrateModal(false);
    setAddTaxModal(true);
  };

  const fetchTaxDetails = (searchParams) => {
    getTaxes(searchParams);
  };

  const onItemSearch = (itemSearch) => {
    const sortParams = '&sortBy=name&direction=ASC';
    const currentPage = 1;
    const filterParams = '';
    debouncedFetchInventoryItems({
      currentPage, sortParams, filterParams, nameSearch: itemSearch ? (itemSearch === '' ? null : `&name.LIKE=${itemSearch}`) : null,
    });
  };

  const onProductSearch = (productSearch) => {
    getProductsList(productSearch);
  };

  const updateTax = (taxes: Array) => {
    setAllSelectedTaxrates(taxes);
  };

  const updateTaxrate = (Taxrate: Object) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.push(Taxrate);
    setAllSelectedTaxrates(listOfTaxes);
    setSelectTaxrateModal(false);
  };

  const removeTax = (i) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.splice(i, 1);
    setAllSelectedTaxrates(listOfTaxes);
  };

  const addTaxrate = (taxRate: Object) => {
    const {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      taxDescription,
    } = taxRate;
    const params = {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      description: taxDescription,
    };
    addNewTaxRate({
      params,
    });
    subScriptionModal(true);
    setTaxRedirect(true);
  };

  useEffect(() => {
    setCustomerList(customerResult);
    if (subscriptionDetails && subscriptionDetails.gid) {
      const displayFormat = moment(subscriptionDetails.planStartDate).format(dateFormat);
      setPlanDate(displayFormat);
      setApiPlanDate(subscriptionDetails.planStartDate);
      setDisableSubscriptionPlan(true);
    } else {
      const displayFormat = moment().utc().tz(selectedAccount.timezone).startOf('day')
        .format(dateFormat);
      // eslint-disable-next-line
      const selectedDate = moment.utc().tz(selectedAccount.timezone).startOf('day').utc().format(MOMENT_FORMAT);
      if (selectedAccount && selectedAccount.timezone) {
        setPlanDate(displayFormat);
        setApiPlanDate(selectedDate);
      }
    }
  }, []);

  useEffect(() => {
    if (current === 2 && !submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  useEffect(() => {
    setRefArray(existingElements => (
      [...existingElements]
    ));
  }, []);

  const next = async () => {
    const validationArray = [];
    const valuesArray = [];
    if (current === 0) {
      validationArray.push(refArray[0].current.validate());
      valuesArray.push(refArray[0].current.getValues());
      if (!validationArray[0]) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return;
      }
      setPlanAmount(valuesArray[0].amount);
      setBillAmount(valuesArray[0].billAmount);
      setPlanName(valuesArray[0].planName);
      setShippingAmount(valuesArray[0].shippingAmount);
      setPeriod(valuesArray[0].period);
      setDescriptions(valuesArray[0].description);
      setRedirectUrl(valuesArray[0].redirectUrl);
      setDelayStartDate(valuesArray[0].delayStartDate);
      setFreeTrialDays(valuesArray[0].freeTrialDays);
      setFeesType(valuesArray[0].feesType);
      setOverdueFee(valuesArray[0].overdueFee);
      setLimitPaymentMethods(valuesArray[0].limitPaymentMethods);
      setAllowManualPayment(valuesArray[0].allowManualPayment);
      setNextAttempt(valuesArray[0].nextAttempt);
      setAddToPlanManager(valuesArray[0].addToPlanManager);
      setPauseType1(valuesArray[0].pauseType);
      setEmail1(valuesArray[0].email1);
      setCounts(valuesArray[0].count);
      setQtys(valuesArray[0].qty);
      setPlanDate(valuesArray[0].dop);
      setStartDates(valuesArray[0].startDate);
      setPfrequency(valuesArray[0].frequency);
      setPlansGid(valuesArray[0].planGid);
      setApiPlanDate(valuesArray[0].planApiDate);
      setApplicationFee(valuesArray[0].applicationFee ? valuesArray[0].applicationFee : '0.00');
      setDisableSubscriptionPlan(valuesArray[0].disablePlanDetails);
      setSubScriptionAmount(valuesArray[0].subscriptionAmount);
      setPrefix(valuesArray[0].prefix);
      setCurrencyCode(valuesArray[0].currencyCode);
      setNotify(valuesArray[0].notify);
      setLineItemDtosList(valuesArray[0].lineItemDtoList);
      setCupoAaddon(valuesArray[0].cupoAaddon);
      setAllRatesAaddon(valuesArray[0].allRatesAaddon);
      setTotalAmount(valuesArray[0].totalAmount);
      setCustomersGid(valuesArray[0].customerGid);
      setCustomerName(valuesArray[0].customersName);
      setSurCharge(valuesArray[0].surCharge);

      let finalLineItems = [];
      if (valuesArray[0].disablePlanDetails) {
        let listFinal = {};
        for (let i = 0; i < valuesArray[0].lineItemDtoList.length; i += 1) {
          listFinal.itemGid = valuesArray[0].lineItemDtoList[i].item.gid;
          listFinal.quantity = valuesArray[0].lineItemDtoList[i].quantity;
          listFinal.upfront = valuesArray[0].lineItemDtoList[i].upfront;
          listFinal.currencyCode = valuesArray[0].lineItemDtoList[i].currencyCode;
          finalLineItems.push(listFinal);
          listFinal = {};
        }
      } else {
        for (let i = 0; i < valuesArray[0].lineItemDtoList.length; i += 1) {
          valuesArray[0].lineItemDtoList[i].productGid = valuesArray[0].lineItemDtoList[i].productGid || null;
          valuesArray[0].lineItemDtoList[i].itemGid = valuesArray[0].lineItemDtoList[i].itemGid || null;
        }
        finalLineItems = [...valuesArray[0].lineItemDtoList];
      }

      const taxlist = [];
      for (let i = 0; i < allSelectedTaxrates.length; i += 1) {
        taxlist.push(allSelectedTaxrates[i]?.taxRates?.gid);
      }

      const payload = {
        currencyCode: valuesArray[0].currencyCode,
        customerGid: valuesArray[0].customerGid,
        plan2Gid: valuesArray[0].planGid ? valuesArray[0].planGid : null,
        redirectUrl: valuesArray[0].redirectUrl,
        plan2BillingPeriod: valuesArray[0].period,
        plan2BillingFrequency: valuesArray[0].frequency,
        plan2StartDate: ((valuesArray[0].delayStartDate > 0 || valuesArray[0].freeTrialDays > 0) ? null : valuesArray[0].planApiDate),
        plan2TotalPayments: Number(valuesArray[0].count),
        description: valuesArray[0].description,
        notificationType: valuesArray[0].notify,
        emailRecipientList: [
          valuesArray[0].email1,
        ],
        delayStartDays: ((valuesArray[0].freeTrialDays > 0) ? null : Number(valuesArray[0].delayStartDate)),
        freeTrialDays: ((valuesArray[0].delayStartDate > 0) ? null : Number(valuesArray[0].freeTrialDays)),
        overDueFees: valuesArray[0].feesType === 'PERCENT' ? Number(valuesArray[0].overdueFee) : (Number(valuesArray[0].overdueFee) * 100),
        overDueFeeType: valuesArray[0].feesType,
        savedPaymentsLimit: Number(valuesArray[0].limitPaymentMethods),
        nextChargeAttemptDelayDays: Number(valuesArray[0].nextAttempt),
        canCustomerCancelOrPause: valuesArray[0].pauseType1 === 'YES',
        allowManualPayments: valuesArray[0].allowManualPayment,
        subscription2LineItems: finalLineItems,
        taxRates: taxlist,
        couponGid: updatedCoupon?.gid || null,
        shippingAmount: shippingAmount ? Number(((shippingAmount).replace('.', '').replace(',', ''))) : null,
      };
      if (valuesArray[0].pauseType1 === 'YES') {
        payload.allowCustomerPauseOrCancel = true;
        payload.subscriptionChargeType = valuesArray[0].surCharge;
      }
      subScriptionModal(false);
      submit(
        payload,
      );
    }
  };

  const getListProducts = () => {
    getProductsList();
  };

  const addSelectedItem = (customer: Object) => {
    const {
      name,
      price,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      isPos,
      priceType,
      primaryColor,
      categories,
      order,
      modifierGroups,
      isItemAvailable,
      cost,
      logoUrl,
      // eslint-disable-next-line no-shadow
      description,
      tagDetails,
      enableStock,
      enableDynamicAvailability,
      stockQuantity,
      onlineAvailability,
      posAvailability,
      shopDetails,
      isRecurring,

    } = customer;
    const totalPrice = price ? price.replace(/[^\d]/g, '') : 0;
    const totalCost = cost ? cost.replace(/[^\d]/g, '') : 0;

    const params = {
      name,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      price: Number(totalPrice),
      hidden: !isPos,
      priceType,
      sortOrder: Number(order),
      colorCode: primaryColor,
      categoryGids: categories || null,
      shopGids: shopDetails || [],
      modifierGroupGids: modifierGroups || null,
      available: isItemAvailable,
      cost: Number(totalCost),
      imageUrl: logoUrl,
      description,
      tagGids: tagDetails || [],
      enableStock,
      enableDynamicAvailability,
      stockQuantity: Number(stockQuantity),
      onlineAvailability: Number(onlineAvailability * 100),
      posAvailability: Number(posAvailability * 100),
      recurring: isRecurring,
    };
    addInventoryItems({
      params,
    });
    setAddedItem(true);
    hanldleAddInventoryRedirect(true);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      width="640px"
      footer={
        [
          <SpButton key="1" onClick={() => close()} type="secondary">Cancel</SpButton>,
          <SpButton key="2" onClick={next} disabled={disableButton}>Create Subscription</SpButton>,
        ]
      }
      title="Add Subscription"
    >
      <>
        <div className="px-5 mt-2">
          <div className={submitting ? 'OVERLAY' : ''} />
          <PlanDetails
            ref={refArray[0]}
            selectedAccount={selectedAccount}
            planData={planData}
            fetchPlanDetails={fetchPlanDetails}
            applyCoupon={applyCoupon}
            updatedCoupon={updatedCoupon}
            applyTaxRate={applyTaxRate}
            allSelectedTaxrates={allSelectedTaxrates}
            supportedCurrency={supportedCurrency}
            removeCoupon={removeCoupon}
            role={role}
            removeTax={removeTax}
            productsList={productsList}
            getListItems={getListItems}
            addNewProductforPlan={addNewProductforPlan}
            addNewItemforPlan={addNewItemforPlan}
            addNewCuponforPlan={addNewCuponforPlan}
            addNewTaxforPlan={addNewTaxforPlan}
            addedNewProduct={addedNewProduct}
            addedProduct={addedProduct}
            addedItem={addedItem}
            onItemSearch={onItemSearch}
            inventoryItems={inventoryItems}
            legacySubscriber={legacySubscriber}
            getListProducts={getListProducts}
            onProductSearch={onProductSearch}
            getDataItems={getDataItems}
            addedNewItem={addedNewItem}
            updateShippingAmount={updateShippingFee}
            updateCoupon={updateCoupon}
            updateTax={updateTax}
            fetchCustomerDetails={fetchCustomerDetails}
          />
          {/* ADD PRODUCT MODAL */}
          {addProductModal && (
            <AddNewProduct
              visible={addProductModal}
              submitting={submitting}
              supportedCurrency={supportedCurrency}
              close={() => setAddProductModal(false)}
              submit={addNewProduct}
              selectedAccount={selectedAccount}
            />
          )}
          {/* ADD ITEM MODAL */}

          {addItemModal && (
            <AddItem
              visible={addItemModal}
              submitting={submitting}
              itemsList={itemsList && itemsList}
              modifierItemsList={modifierItemsList && modifierItemsList}
              labelList={labelList && labelList}
              selectedAccount={selectedAccount}
              close={() => setAddItemModal(false)}
              submit={addSelectedItem}
            />
          )}
          {/* SELECT COUPON MODAL */}
          {selectCouponModal && (
            <SelectCoupon
              visible={selectCouponModal}
              submitting={submitting}
              close={() => setSelectCouponModal(false)}
              submit={updateCoupon}
              newCouponAdd={newCouponAdd}
            />
          )}

          {/* ADD COUPON MODAL */}
          {addCouponModal && (
            <AddCoupon
              visible={addCouponModal}
              submitting={submitting}
              close={() => setAddCouponModal(false)}
              submit={addCoupon}
              selectedAccount={selectedAccount}
              allCustomers={customerResult}
              fetchCustomer={fetchCustomer}
            />
          )}

          {/* SELECT TAXRATE MODAL */}
          {selectTaxrateModal && (
            <SelectTaxrate
              visible={selectTaxrateModal}
              submitting={submitting}
              close={() => setSelectTaxrateModal(false)}
              submit={updateTaxrate}
              newTaxAdd={newTaxAdd}
            />
          )}

          {/* ADD TAX MODAL */}
          {addTaxModal && (
            <AddTaxrate
              visible={addTaxModal}
              submitting={submitting}
              close={() => setAddTaxModal(false)}
              submit={addTaxrate}
              selectedAccount={selectedAccount}
              allTaxes={allTaxes}
              fetchTaxDetails={fetchTaxDetails}
            />
          )}
        </div>
      </>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  products: state.subscription.products.content,
  planResult: state.subscriptionv2.plans.content,
  customerResult: state.invoiceDetails.customersList,
  productsList: state.invoiceDetails.productsList,
  productResult: state.subscription.productsearch.content,
  addedNewProduct: state.invoiceDetails.newProduct,
  plans: state.planv2.content,
  test: state.account.test,
  submitting: state.loading.submitting,
  selectedAccount: state.account.selectedAccount,
  validator: state.loading.validator,
  newCoupon: state.invoiceDetails.newCoupon,
  taxList: state.invoiceDetails.taxList,
  newTaxrate: state.invoiceDetails.newTaxrate,
  inventoryItems: state.inventoryItems.content,
  internalAccount: state.account.internalAccount,
  modifierItemsList: state.inventoryItems.modifierItemsList.content,
  itemsList: state.inventoryItems.itemsList.content,
  labelList: state.inventoryPrinterLabel.labelList.content,
  addedNewItem: state.inventoryItems.addedItem.entity,
});

const mapDispatchToProps = (dispatch) => ({
  fetchInventoryItems: param => dispatch(inventoryItemsActions.fetchInventoryItems({
    payload: param,
  })),
  fetchPlanV2Search: param => dispatch(subscriptionv2Actions.fetchPlanV2Search({
    payload: param,
  })),
  getCustomersList: param => dispatch(invoiceDetailsAction.getCustomersList({
    payload: param,
  })),
  getProductsList: param => dispatch(invoiceDetailsAction.getProductsList({
    payload: param,
  })),
  addNewProcut: param => dispatch(invoiceDetailsAction.addNewProcut({
    payload: param,
  })),
  addNewCoupon: param => dispatch(invoiceDetailsAction.addNewCoupon({
    payload: param,
  })),
  getTaxes: param => dispatch(invoiceDetailsAction.getTaxes({
    payload: param,
  })),
  addNewTaxRate: param => dispatch(invoiceDetailsAction.addNewTaxRate({
    payload: param,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchItemsList: param => dispatch(inventoryItemsActions.fetchItemsList({
    payload: param,
  })),
  fetchPrinterLabelList: (payload) => dispatch(inventoryPrinterLabelActions.fetchPrinterLabelList({
    payload,
  })),
  fetchModifierItemsList: param => dispatch(inventoryItemsActions.fetchModifierItemsList({
    payload: param,
  })),
  addInventoryItems: param => dispatch(inventoryItemsActions.addInventoryItems({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(AddSubscription);
